import React from 'react'
import { useFormContext } from 'react-hook-form'
import useSessionStorage from '../../hooks/useSessionStorage'
import { initialFields } from '../../consts'

export default function Escalera({ title, label, required = false }) {
  const {
    register,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext()

  const [storageData, setStorageData] = useSessionStorage(
    'app_data',
    initialFields
  )

  const handleChange = () => {
    setStorageData(getValues())
  }

  return (
    <div className="form-field">
      {title && <span>{title}</span>}
      <div className="form-group">
        <label htmlFor="MCCPERSTAG.TOMADOR.Escalera">
          {label || 'Escalera'}
        </label>
        <input
          id="MCCPERSTAG.TOMADOR.Escalera"
          className={`form-control${
            errors?.MCCPERSTAG?.TOMADOR?.Escalera ? ' hasError' : ''
          }`}
          type="text"
          {...register('MCCPERSTAG.TOMADOR.Escalera', {
            onChange: handleChange,
            required: required === true ? 'La Escalera es obligatoria.' : false,
            pattern: {
              value: /^[A-Za-z0-9-]*$/i,
              message: 'Has introducido caracteres no permitidos.',
            },
            maxLength: {
              value: 10,
              message: 'El Escalera es demasiado larga.',
            },
          })}
        />
      </div>

      {errors?.MCCPERSTAG?.TOMADOR?.Escalera && (
        <div className="error">
          <p>{errors.MCCPERSTAG.TOMADOR.Escalera.message}</p>
        </div>
      )}
    </div>
  )
}
